import React from "react"
import { useMutation, gql } from "@apollo/client"
import { Box, Button, Divider, Autocomplete, TextField } from "@mui/material"
import ChooseSingleLocation from "../../components/Map/ChooseSingleLocation"
import { defaultLat, defaultLng } from "../../constants"
import PaperWithHeading from "../../components/Layout/PaperWithHeading"

// Mutation to create a new farm with hasura
const CREATE_FARM = gql`
  mutation CreateFarm(
    $name: String!
    $properties: jsonb!
    $map_center: geo_location_obj_rel_insert_input!
    $wave_buoys_to_farm: [wave_buoy_to_farm_insert_input!]!
  ) {
    insert_farm(
      objects: {
        properties: $properties
        name: $name
        geo_location: $map_center
        wave_buoy_to_farms: { data: $wave_buoys_to_farm }
      }
    ) {
      returning {
        id
        name
        properties
      }
    }
  }
`

export default function AddFarm({ waveBuoys }) {
  const [createFarm] = useMutation(CREATE_FARM)
  const [selectedWaveBuoys, setSelectedWaveBuoys] = React.useState([])
  const [name, setName] = React.useState("")
  const [marker, setMarker] = React.useState({
    latitude: defaultLat,
    longitude: defaultLng,
  })

  const selectedWaveBuoysIds = waveBuoys
    .filter((waveBuoy) => selectedWaveBuoys.includes(waveBuoy.name))
    .map((waveBuoy) => waveBuoy.id)
  const wave_buoys_to_farm = [
    ...selectedWaveBuoysIds.map((wave_buoy_id) => ({
      wave_buoy_id,
    })),
  ]

  return (
    <PaperWithHeading title="Add New Farm">
      <Box style={{ height: 350, width: "100%", marginBottom: 100 }}>
        <ChooseSingleLocation marker={marker} setMarker={setMarker} />
      </Box>
      <TextField
        label="Farm name"
        value={name}
        onChange={(event) => setName(event.target.value)}
      />
      <Autocomplete
        disablePortal
        multiple
        id="combo-box-demo"
        options={waveBuoys.map((waveBuoy) => waveBuoy.name)}
        sx={{ width: 300 }}
        renderInput={(params) => <TextField {...params} label="Wave buoy" />}
        value={selectedWaveBuoys}
        onChange={(event, newInputValue) => setSelectedWaveBuoys(newInputValue)}
      />

      <Divider />

      <Button
        variant="contained"
        style={{ marginTop: 75 }}
        onClick={() =>
          createFarm({
            variables: {
              name: name,
              properties: {},
              wave_buoys_to_farm,
              map_center: {
                data: {
                  geo_json: {
                    type: "Point",
                    coordinates: [marker.longitude, marker.latitude],
                  },
                },
              },
            },
          })
        }
      >
        Create Farm
      </Button>
    </PaperWithHeading>
  )
}
